module.exports = __webpack_public_path__ + "img/float_sprite.b8c806f7.png";